import APIConfig from './api';
import ErrorMessages from './errors';
import CUSTOM_MESSAGES from './customMessage';
import APP_CONFIG from './appConfig';
import ERROR_LABEL from './errorLabel';
import TEMPLATES from './templates';
import LABEL from './label';
import SUCCESS_MESSAGE from './successMessages';
import ERROR_MESSAGE from './errorMessage';
import COUNTRY_CODE from './countryCodes';

export {
  APIConfig,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ErrorMessages,
  CUSTOM_MESSAGES,
  ERROR_LABEL,
  APP_CONFIG,
  TEMPLATES,
  LABEL,
  COUNTRY_CODE
};
